module.exports = "d218f7e06e5c038e77083fbcdc9d8377.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/play-text.png
// module id = 39
// module chunks = 0